<template>
  <div v-if="hasForms" class="more_form_container my-3">
    <p>{{ multiLanguage.ProductOtherForms }}</p>
    <div
      class="other-forms-group mt-2 mb-3 d-flex align-items-center overflow-auto"
      style="gap: 10px"
    >
      <div v-for="(item, index) in formItems" :key="index" class="item">
        <a v-if="item.picUrl && item.url" :href="item.url" aria-label="Form">
          <img
            :src="item.picUrl"
            alt="Form"
            width="45"
            height="45"
            loading="lazy"
            decoding="async"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OtherForms",
  props: {
    itemId: {
      default: null,
    },
    multiLanguage: Object,
  },
  data() {
    return {
      formItems: [
        {
          varId: "",
          itemId: "",
          picUrl: null,
          url: "",
        },
        {
          varId: "",
          itemId: "",
          picUrl: null,
          url: "",
        },
        {
          varId: "",
          itemId: "",
          picUrl: null,
          url: "",
        },
        {
          varId: "",
          itemId: "",
          picUrl: null,
          url: "",
        },
        {
          varId: "",
          itemId: "",
          picUrl: null,
          url: "",
        },
      ],
    };
  },
  computed: {
    currentVariation() {
      const variation =
        this.$store.getters[`${this.$props.itemId}/currentItemVariation`];
      if (
        variation &&
        variation.variationProperties &&
        variation.variationProperties.length > 0
      ) {
        return variation.variationProperties[0].properties || [];
      }
      return [];
    },
    hasForms() {
      return this.formItems.some((item) => {
        if (item.picUrl) return true;
        return false;
      });
    },
  },
  methods: {
    updateFormItemData(itemIndex, varIdKey, itemIdKey, picUrlKey) {
      const item = this.formItems[itemIndex];
      this.currentVariation.forEach((elem) => {
        if (elem.id === varIdKey) {
          item.varId = elem.values.value;
        }
        if (elem.id === itemIdKey) {
          item.itemId = elem.values.value;
        }
        if (elem.id === picUrlKey) {
          item.picUrl = elem.values.value;
          item.url = `${window.location.href.split("_")[0]}_${item.varId}_${
            item.itemId
          }`;
        }
      });
    },
    updateUI() {
      const keys = [
        [0, 693, 694, 692],
        [1, 695, 699, 703],
        [2, 696, 700, 704],
        [3, 697, 701, 705],
        [4, 698, 702, 706],
      ];
      keys.forEach(([index, varIdKey, itemIdKey, picUrlKey]) => {
        this.updateFormItemData(index, varIdKey, itemIdKey, picUrlKey);
      });
    },
  },
  watch: {
    currentVariation: "updateUI",
  },
  mounted() {
    this.updateUI();
  },
};
</script>
